export default __webpack_public_path__ + "static/media/rolls-royce.71db7bb3.png";